module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.layerSelectorActive) ? _c('ul', {
    attrs: {
      "id": "layer-selector"
    }
  }, [_c('item', {
    staticClass: "item",
    attrs: {
      "conf": _vm.groups
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c86faa5","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LayerSelector.vue
// module id = 632
// module chunks = 2